import React, { Fragment, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles"
import { ToastContainer } from "react-toastify"
import { useSelector } from "react-redux"

import "./App.scss"
import Header from "./components/Header"
import Footer from "./components/Footer/Footer"
import ScrollToTop from "./helpers/scrollToTop"
import { paths } from "./routes/paths"
import {
  initializeMarkerIO,
  isMarkerIOUserAllowed,
  hideMarkerIO,
} from "./services/markerIOService"

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: 768,
      lg: 1440,
      xl: 1920,
    },
  },
})

function App({ children }) {
  const location = useLocation()
  const userInfo = useSelector((state) => state.user)
  const markerWarningShownRef = useRef(false)
  const markerProjectId = process.env.REACT_APP_MARKER_IO_PROJECT_ID

  // Initialize Marker.io widget
  useEffect(() => {
    const canUseMarker = isMarkerIOUserAllowed(userInfo)

    if (!markerProjectId) {
      if (!markerWarningShownRef.current) {
        console.warn(
          "Marker.io project ID not found.",
        )
        markerWarningShownRef.current = true
      }
      return
    }

    if (!canUseMarker) {
      hideMarkerIO()
      return
    }

    initializeMarkerIO(markerProjectId).catch((error) => {
        console.error("Failed to initialize Marker.io:", error)
      })
  }, [markerProjectId, userInfo?.uuid, userInfo?.role])

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer
        autoClose={4000}
        position="top-right"
        hideProgressBar
        newestOnTop
        closeOnClick
        className="custom-toast-component"
      />
      <ScrollToTop />

      <div className="mainWrapper">
        {location.pathname !== paths.companyProviderLanding &&
        location.pathname !== paths.individualLanding ? (
          <Fragment>
            <Header />
            <div className="content">{children}</div>
            <Footer />
          </Fragment>
        ) : (
          <>{children}</>
        )}
      </div>
    </ThemeProvider>
  )
}

export default App
